import { render } from "./ReportFileProperties.vue?vue&type=template&id=7ed3c17f"
import script from "./ReportFileProperties.vue?vue&type=script&lang=js"
export * from "./ReportFileProperties.vue?vue&type=script&lang=js"

import "./ReportFileProperties.vue?vue&type=style&index=0&id=7ed3c17f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__